module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qurin3-4e655e0715208db523b240a259b72bce.jpg";